// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5255":"3efe71095b7cafad","6004":"98470c121736e5ef"}[chunkId] + ".css";
};